var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn-default"},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.$t('skip')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }